import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "../../lib/utils.js";
function Skeleton({ className, ...props }) {
    return (_jsx("div", { "data-slot": "skeleton", "aria-hidden": "true", className: cn('animate-pulse rounded-lg bg-slate-100', className), ...props }));
}
export { Skeleton };
//# sourceMappingURL=skeleton.js.map